export const getCardImageProperties = ({
  cardProgramNumber = null,
  countryCode = '',
  cardOfferType = '',
  plasticTypes = []
} = {}) => ({ cardProgramNumber, countryCode, cardOfferType, plasticTypes })
